import React from 'react';
import sitemap from "../assets/sitemap.pdf";

export default function SiteMap() {
    // Check if the URL path includes '/en'
    const isEnglish = window.location.pathname.includes('/en');

    return (
        <div style={styles.pageWrapper}>
            <div style={styles.card}>
                <h2 style={styles.heading}>
                    🗺️ {isEnglish ? 'Site Map' : 'साइट मैप'}
                </h2>
                <p style={styles.description}>
                    {isEnglish
                        ? 'The document below shows the complete structure of the website. You can view or download the PDF file.'
                        : 'नीचे दिया गया दस्तावेज़ वेबसाइट की संपूर्ण संरचना दर्शाता है। आप PDF फ़ाइल को देख सकते हैं या डाउनलोड कर सकते हैं।'}
                </p>

                {/* PDF View - opens in a new tab */}
                <div style={styles.downloadSection}>
                    <a
                        href={sitemap}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ ...styles.downloadButton, backgroundColor: '#28a745', marginRight: '12px' }}
                    >
                        {isEnglish ? '👁️ View PDF' : '👁️ PDF देखें'}
                    </a>

                    {/* PDF Download */}
                    <a
                        href={sitemap}
                        download
                        style={styles.downloadButton}
                    >
                        {isEnglish ? '⬇️ Download PDF' : '⬇️ PDF डाउनलोड करें'}
                    </a>
                </div>
            </div>
        </div>
    );
}

const styles = {
    pageWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
        backgroundColor: '#f4f4f4',
        minHeight: '100vh',
    },
    card: {
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        padding: '30px',
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center',
    },
    heading: {
        fontSize: '26px',
        color: '#333',
        marginBottom: '10px',
    },
    description: {
        fontSize: '16px',
        color: '#666',
        marginBottom: '30px',
    },
    downloadSection: {
        display: 'flex',
        justifyContent: 'center',
        gap: '10px',
    },
    downloadButton: {
        backgroundColor: '#007bff',
        color: '#fff',
        textDecoration: 'none',
        padding: '12px 22px',
        borderRadius: '6px',
        fontWeight: '600',
        fontSize: '15px',
        transition: 'background-color 0.3s ease',
        cursor: 'pointer',
        userSelect: 'none',
    },
};
